import { PlayerCard } from "@/components/PlayerCard";
import { SPORTS } from "@/constants/sports";

export const MatchCard = ({ m, index }) => {
  const accent = SPORTS[m.player.sport]?.accent || "#FF2D78";
  return (
    <div data-testid={`match-card-${m.player.id}`} className="flex flex-col gap-3">
      <PlayerCard p={m.player} index={index} />
      <div className="rounded-lg border border-slate-800 bg-[#131927] p-3">
        <div className="flex items-center gap-3">
          <span className="eyebrow">Match</span>
          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-800">
            <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${m.score}%`, background: accent }} />
          </div>
          <span data-testid={`match-score-${m.player.id}`} className="font-data text-sm font-bold text-white">{m.score}</span>
        </div>
        {m.reasons.length > 0 && (
          <div className="mt-2.5 flex flex-wrap gap-1.5">
            {m.reasons.map((r) => (
              <span key={r} className="rounded-full border px-2 py-0.5 text-[11px] text-slate-200" style={{ borderColor: `${accent}66`, background: `${accent}14` }}>{r}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
